import instance, { Url } from "./globalaxios";

/**
 * Fetch SEBI Analytics data from the backend API
 * @returns {Promise} Promise with disputes and NSDL data
 */
export const fetchSebiAnalyticsData = async (params) => {
  try {
    const response = await instance.get(`/get-analytics/sebi/`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching SEBI analytics data:", error);
    throw error;
  }
};

/**
 * Format raw API data into chart format
 * @param {Array} rawData - Raw data from API
 * @returns {Array} Formatted data for charts
 */
export const formatChartData = (rawData) => {
  if (!Array.isArray(rawData)) {
    return [];
  }

  return rawData.map((item) => ({
    label: item.label || item.name || "Unknown",
    value: item.value || item.count || 0,
  }));
};
